import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getItemWithUserData, postItem } from '../../../api/items';

import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import { mergeItemWithUserData } from '../../../utils/items';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const createItem = createAsyncThunk(
  'items/createItem',
  async ({ path, body, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const [itemRes, userdataRes] = await postItem(
        { path, body, params },
        {
          cancelToken: source.token,
        },
      );

      const { orgId, streamId, channelId, id: streamItemId } = itemRes.data;

      if (
        itemRes.data.metadata.locked === true ||
        itemRes.data.content.processed === 'Processed'
      ) {
        return mergeItemWithUserData(itemRes, userdataRes);
      }

      const [itemResponse, userdataResponse] = await getItemWithUserData({
        path: { orgId, streamId, channelId, streamItemId },
      });

      return mergeItemWithUserData(itemResponse, userdataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const createItemExtraReducers = builder => {
  builder
    .addCase(createItem.pending, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      checkAndSetLoadingWithId(
        state.items.item.actions.create.request,
        action,
        itemCIDKey,
      );
    })
    .addCase(createItem.fulfilled, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.items.item.actions.create.request[itemCIDKey],
        action,
        () => {
          const payloadItemCIDKey = generateItemCIDKey(action.payload);
          state.items.item.byId[payloadItemCIDKey] = action.payload;
          state.items.item.allIds.push(payloadItemCIDKey);

          state.isShownNewBuzzNotification = false;
        },
      );
    })
    .addCase(createItem.rejected, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      handleRequestRejection(
        state.items.item.actions.create.request[itemCIDKey],
        action,
      );
    });
};
